import PropTypes from "prop-types"

export const HtmlStylesType = PropTypes.shape({
  paragraph: PropTypes.shape({
    color: PropTypes.string,
    lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fontSize: PropTypes.string,
  }),
  heading: PropTypes.shape({
    color: PropTypes.string,
  }),
  link: PropTypes.shape({
    color: PropTypes.string,
  }),
  list: PropTypes.shape({
    color: PropTypes.string,
    lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  youtube: PropTypes.shape({
    poster: PropTypes.string,
  }),
})
